import { inject, Service } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import type { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Auth0Store } from '../store';
import { LoginGuard } from './login.guard';
import { FeatureBit } from '../models/feature-bits.model';

import { RootRouteStore } from '../../../store';

@Service()
export class FeatureBitsGuard {
  private loginGuard = inject(LoginGuard);
  private auth0Store = inject(Auth0Store);
  private router = inject(Router);
  private routeStore = inject(RootRouteStore);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return (this.loginGuard.canActivate(route, state) as Observable<boolean>).pipe(
      map((loggedIn) => {
        const featureBits = this.auth0Store.featureBits();
        const prevUrl = this.routeStore.previousRouteUrl();
        if (!featureBits) return false;

        let value = false;
        if (route.data.featureBitOrList) {
          value = loggedIn ? (route.data.featureBitOrList as FeatureBit[]).some((fb) => featureBits?.[fb]) : false;
        } else {
          value = loggedIn ? featureBits[route.data?.featureBit as FeatureBit] : false;
        }

        if (!value && !prevUrl) {
          route.data.redirectUrl
            ? this.router.navigate([route.data.redirectUrl])
            : this.router.navigate(['/clinical-db']);
        }

        return value;
      }),
      take(1),
    );
  }
}
